export const ICC_PRODUCT_STATUS_TYPES = {
    FAILED: 'Failed',
    REGISTERED: 'Registered',
    REGISTERING: 'Registering',
    UNREGISTERED: 'Unregistered',
    UNREGISTERING: 'Unregistering',
};
